import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import './index.css';

import { Provider } from 'react-redux';

import store from './store';
import App from './App';

import moment from 'moment';
import _ from 'moment/locale/nl.js'; // eslint-disable-line no-unused-vars
import momentDurationFormatSetup from 'moment-duration-format';
import * as Sentry from '@sentry/browser';
import version from './version.json';
import * as translations from "./translations";

Sentry.init({
  dsn: 'https://a3528912ab294811b242e3d0b3907d80@o279754.ingest.sentry.io/1502918',
  release: `donniebase@${version}`,
  environment: window.location.hostname.replace(/\./g, '-')
});

translations.init();

momentDurationFormatSetup(moment);
moment.locale('nl');

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
